import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Shield, Warning } from "@phosphor-icons/react";

export default function AdminRateLimits() {
  const [d, setD] = useState(null);
  const [hours, setHours] = useState(24);
  const load = () => api.get(`/admin/rate-limits?hours=${hours}`).then((r) => setD(r.data));
  useEffect(() => { load(); }, [hours]);
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <Shield size={28} className="text-blue-600" />
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-slate-900">Rate limits</h1>
      </div>
      <div className="flex items-center gap-3">
        <label className="label-caps">Window</label>
        <select value={hours} onChange={(e)=>setHours(Number(e.target.value))} data-testid="rl-hours" className="h-9 border border-slate-300 rounded-md px-2 text-sm bg-white">
          <option value={1}>1 hour</option><option value={6}>6 hours</option><option value={24}>24 hours</option><option value={168}>7 days</option>
        </select>
        <div className="text-sm text-slate-600">Total 429s: <strong className="text-slate-900">{d?.total ?? 0}</strong></div>
      </div>
      <div className="card-tactile overflow-hidden">
        <div className="grid grid-cols-12 px-4 py-3 border-b border-slate-200 bg-slate-50 label-caps">
          <div className="col-span-3">IP</div><div className="col-span-6">Path</div><div className="col-span-1 text-right">Hits</div><div className="col-span-2 text-right">Last</div>
        </div>
        {(d?.top || []).map((r) => (
          <div key={`${r.ip}-${r.path}`} data-testid={`rl-row-${r.ip}-${r.path.replace(/[^a-zA-Z0-9]/g,'_')}`} className="grid grid-cols-12 px-4 py-2.5 border-b border-slate-100 last:border-0 text-sm items-center">
            <div className="col-span-3 font-mono text-slate-800 truncate">{r.ip}</div>
            <div className="col-span-6 text-slate-700 truncate">{r.path}</div>
            <div className="col-span-1 text-right font-semibold">{r.count}</div>
            <div className="col-span-2 text-right text-slate-500 text-xs">{new Date(r.last_at).toLocaleString()}</div>
          </div>
        ))}
        {(!d || d.top.length === 0) && <div className="p-8 text-center text-slate-500"><Warning size={20} className="mx-auto mb-2 text-emerald-500" weight="fill" /> No throttling recorded — traffic is healthy.</div>}
      </div>
    </div>
  );
}
